import { QuestionTemplateAdapterInteface } from 'src/adapter/QuestionTemplateAdapterInterface';
import {
  QuestionTemplateGetAttributes,
  QuestionTemplateSendAttributes,
} from 'src/models/QuestionTemplateModel';
import { api } from 'boot/axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
export class AxiosQuestionTemplateAdapter
  implements QuestionTemplateAdapterInteface
{
  async createQuestionTemplate(
    attributes: QuestionTemplateSendAttributes
  ): Promise<QuestionTemplateGetAttributes> {
    try {
      const res = await api.post('/question-templates', attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async updateQuestionTemplate(
    id: string,
    attributes: QuestionTemplateSendAttributes
  ): Promise<QuestionTemplateGetAttributes> {
    try {
      const res = await api.put(`/question-templates/${id}`, attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async deleteQuestionTemplate(id: string): Promise<boolean> {
    try {
      return await api.delete(`/question-templates/${id}`);
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
}
